// ACTION TYPES //
export const LOAD_REPORT = 'report/load-report'
export const LOAD_REPORT_FINISHED = 'report/load-report-finished'
export const LOAD_REPORT_FAILED = 'report/load-report-failed'
export const LOAD_REPORT_PREVIEW = 'report/load-report-preview'

export const LOAD_REPORT_VERIFICATION = 'report/load-report-verification'
export const LOAD_REPORT_VERIFICATION_FINISHED = 'report/load-report-verification-finished'
export const LOAD_REPORT_VERIFICATION_FAILED = 'report/load-report-verification-failed'

// ACTIONS //
export const loadReport = (code) => ({
  type: LOAD_REPORT,
  payload: code
})

export const loadReportFinished = (data) => ({
  type: LOAD_REPORT_FINISHED,
  payload: data
})

export const loadReportFailed = (name, msg) => ({
  type: LOAD_REPORT_FAILED,
  payload: { name, msg }
})

export const loadReportPreview = (payload) => ({
  type: LOAD_REPORT_PREVIEW,
  payload
})

export const loadReportVerification = (code) => ({
  type: LOAD_REPORT_VERIFICATION,
  payload: code
})

export const loadReportVerificationFinished = () => ({
  type: LOAD_REPORT_VERIFICATION_FINISHED
})

export const loadReportVerificationFailed = (name, msg) => ({
  type: LOAD_REPORT_VERIFICATION_FAILED,
  payload: { name, msg }
})
